import React, { useState, useEffect } from 'react'
import './PrepublishMembers.scss'
import {
  Button,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TableHead,
  TableContainer,
  Paper,
  Checkbox,
  TableSortLabel
} from '@mui/material'
import { useCMSContext } from './../../CMSContext'
import PrepublishMembersActions from './PrepublishMembersActions'
import { PrepublishMembersFunctions } from './PrepublishMembersFunctions'
import { IARDialog } from '../../../Shared/Dialog/IARDialog'
import { useErrorSnackBarContext } from '../../../Shared/ErrorSnackBar/ErrorSnackBarContext'

function PrepublishMembers() {
  const [prepublishMembers, setPrepublishMembers] = useState([])
  const [selected, setSelected] = useState([])
  const [emailState, setEmailState] = useState({
    emailInput: '',
    emailError: false,
    allSelectedCounter: 0,
    checkedBox: false,
    openDialog: false,
    sortState: 'desc'
  })
  const cmsContext = useCMSContext()
  const { fireDepartment, isReadOnlyMember } = cmsContext.state
  const newEmails = PrepublishMembersFunctions.updateEmails(prepublishMembers)
  const emails = PrepublishMembersFunctions.getEmails(selected)
  const { errorSnackBarActions } = useErrorSnackBarContext()

  if (emailState.sortState === 'asc') {
    PrepublishMembersFunctions.ascendingSorting(prepublishMembers)
  } else {
    if (emailState.sortState === 'desc') {
      PrepublishMembersFunctions.descendingSorting(prepublishMembers)
    }
  }

  useEffect(() => {
    PrepublishMembersActions.getUsers(fireDepartment.identifier).then((res) =>
      setPrepublishMembers(res)
    )
  }, [])

  return (
    <div className="prepublish-members">
      <div className="page-header">
        <span>Preview Ability</span>
      </div>
      <Grid size={{ xs: 12 }}>
        <div className="page-description">
          You can allow some of your members to see a preview of your MyLS app pages as you edit
          them before publishing the new content to your community. For members to have this
          ability, enter their email addresses below. These will need to be the same email addresses
          that they used to create their own account when they logged into the MyLS app and “joined”
          that app. On content pages of your app in this content management tool, you have the
          ability to select “Publish” or “Preview” at the bottom of each page. “Preview” will allow
          the new content to be seen by only the members you add to this page. “Publish” pushes the
          new content to anyone who accesses your app in MyLS.
        </div>
      </Grid>
      <Grid size={{ xs: 12 }} className="erroLabelConatiner">
        <Grid size={{ xs: 12, sm: 6 }} className="item">
          {emailState.emailError && <label className="errorLabel">Invalid E-mail format</label>}
        </Grid>
      </Grid>
      <div className="btn-container">
        <Grid container spacing={3}>
          <Grid size={{ xs: 12, sm: 6 }} className="item">
            <label className="email-label">E-mail:</label>
            <input
              className="add-email"
              value={emailState.emailInput}
              onChange={(e) => setEmailState({ ...emailState, emailInput: e.target.value })}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 3 }} className="item">
            {selected.length > 0 && (
              <Button
                className="btn-red"
                color="secondary"
                style={isReadOnlyMember ? { backgroundColor: 'red' } : {}}
                size="small"
                variant="contained"
                disabled={isReadOnlyMember}
                onClick={() => setEmailState({ ...emailState, openDialog: true })}
              >
                Delete E-mail
              </Button>
            )}
          </Grid>
          <Grid size={{ xs: 12, sm: 3 }} className="item">
            <Button
              className="btn-blue"
              style={isReadOnlyMember ? { backgroundColor: '#1c9cd5' } : {}}
              color="primary"
              size="small"
              variant="contained"
              disabled={isReadOnlyMember}
              onClick={() =>
                PrepublishMembersFunctions.emailRegex.test(emailState.emailInput)
                  ? (PrepublishMembersFunctions.onSubmitNewMember(
                      fireDepartment.fireDepartmentId,
                      fireDepartment.identifier,
                      emailState.emailInput,
                      PrepublishMembersActions.createUser,
                      setPrepublishMembers,
                      prepublishMembers,
                      errorSnackBarActions
                    ),
                    setEmailState({ ...emailState, emailError: false, emailInput: '' }))
                  : PrepublishMembersFunctions.errorMessage(setEmailState, emailState)
              }
            >
              Add E-mail
            </Button>
          </Grid>
        </Grid>
      </div>
      <IARDialog
        open={emailState.openDialog}
        title="Confirm"
        content={
          <div className="dialogContent">
            <div>Do you want to delete the selected emails?</div>
          </div>
        }
        onOk={() =>
          PrepublishMembersFunctions.onDeleteMember(
            fireDepartment.identifier,
            emails,
            newEmails,
            PrepublishMembersActions.deleteUser,
            setSelected,
            setPrepublishMembers,
            emailState,
            setEmailState
          )
        }
        onCancel={() => setEmailState({ ...emailState, openDialog: false })}
      />
      <Grid size={{ xs: 12 }} className="table-container">
        <TableContainer component={Paper}>
          <Table size="small">
            <TableHead>
              <TableRow className="table-header">
                <TableCell>
                  <Checkbox
                    checked={emailState.checkedBox}
                    onClick={() =>
                      PrepublishMembersFunctions.onSelectAllClick(
                        emailState.allSelectedCounter,
                        prepublishMembers,
                        setPrepublishMembers,
                        setSelected,
                        setEmailState,
                        emailState
                      )
                    }
                  />
                  <TableSortLabel
                    active={true}
                    direction={emailState.sortState}
                    onClick={() => {
                      setEmailState((prevState) => ({
                        ...prevState,
                        sortState: prevState.sortState === 'desc' ? 'asc' : 'desc'
                      }))
                    }}
                  >
                    E-mail
                  </TableSortLabel>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {prepublishMembers.length > 0 &&
                prepublishMembers.map((member) => (
                  <TableRow
                    key={`${member.fireDepartmentId}${member.email}`}
                    selected={member.isSelected}
                    onClick={(event) =>
                      PrepublishMembersFunctions.handleRowClick(
                        event,
                        member,
                        selected,
                        setSelected
                      )
                    }
                  >
                    <TableCell className="cell">{member.email}</TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    </div>
  )
}

export default PrepublishMembers
